// import {getPublicImageUrl,getPublicImageUrl} from 'lib/ImageService'
import ImageService from 'lib/ImageService'
import { IMEventBus } from "lib/mp-stjk-im-service"
import getMessageBoxTimeTip from 'lib/MessageBoxTimeService'

Component({
  /**
   * 组件的属性列表
   */
  properties: {
    msg: {
      type: Object,
      value: {},
      observer: function (msgInfo) {
        if (msgInfo.feature) {
          try {
            msgInfo.feature = JSON.parse(msgInfo.feature);
          } catch (e) { }
        }
        if (Object.keys(msgInfo).length > 0) {
          let imgUrl,
            classStr = "cable-message-item";
          // 发送方
          if (msgInfo.userInfo.userId === msgInfo.fromId) {
            if (/^http|https\./.test(msgInfo.userInfo.imgUrl)) {
              imgUrl = msgInfo.userInfo.imgUrl
            } else {
              imgUrl = ImageService.getPublicImageUrl(msgInfo.userInfo.imgUrl)
              // imgUrl = getPublicImageUrl(msgInfo.userInfo.imgUrl)
            }
            classStr = "cable-message-item bubble--alt";
          } else {
            // 接收方
            imgUrl = msgInfo.feature && msgInfo.feature.f3
              ? ImageService.getPublicImageUrl(msgInfo.feature.f3)
              // ? getPublicImageUrl(msgInfo.feature.f3)
              : ImageService.getPublicImageUrl(msgInfo.doctorInfo.imgUrl)
              // : getPublicImageUrl(msgInfo.doctorInfo.imgUrl)
          }
          const data = {
            imgUrl,
            classStr
          };
          if (msgInfo.preMsg) {
            data.timeStr = getMessageBoxTimeTip(
              msgInfo.created,
              msgInfo.preMsg.created
            );
          }
          this.setData(data);
        }
      }
    },
    noBg: Boolean,
    whiteBg: Boolean
  },

  /**
   * 组件的初始数据
   */
  data: {
    classStr: "",
    imgUrl: "",
    timeStr: "",
    isRetryShow: false
  },

  ready: function () {
    let { msg } = this.data;
    if (msg.isNew) {
      IMEventBus.trigger("REFRESH_SCROLLER");
    } else {
      setTimeout(() => {
        this.setData({
          isRetryShow: true
        });
      }, 1500);
    }
  },

  /**
   * 组件的方法列表
   */
  methods: {
    reSendMsg: function () {
      // 重发消息
      if (!this.reSendClick) {
        this.reSendClick = true;
        IMEventBus.trigger("RE_SEND_MESSGE", this.data.msg);
        setTimeout(() => {
          this.reSendClick = false;
        }, 500);
      }
    },
    // 打开医生主页
    goToDoctorMainPage: function () {
      const { msg } = this.data;
      if (msg.userInfo.userId !== msg.fromId) {
        if (msg.userInfo.userId !== msg.fromId) {
          const sdid =
            (msg.feature && msg.feature.sdid) ||
            msg.did;
          const isPrivateIm =
            msg && msg.feature && msg.feature.pid;
          const pid = msg && msg.feature && msg.feature.pid || '0';
          if (isPrivateIm && sdid && pid) {
            IMEventBus.trigger("GO_TO_PRIVATE_DOCTOR_PAGE");
          }
        }
      }
    }
  }
});
